'use client'

import { SubcategoryChip } from '@/components/v3/atoms/subcategory-chip/subcategory-chip'
import { ArticleSubcategory } from '@/types/api/article-category'
import s from './subcategory-chip-slider.module.css'
import { useEffect, useRef, useState } from 'react'

type Props = {
  subcategories: ArticleSubcategory[]
  selectedSubcategory: ArticleSubcategory
}

export const SubcategoryChipSlider = ({
  subcategories,
  selectedSubcategory,
}: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [subCatClicked, setSubCatClicked] = useState(false)

  useEffect(() => {
    const container = containerRef.current
    // to prevent scrolling to the active filter on load more
    const hasPageQueryParam = window.location.search.includes('page=')

    const shouldScrollToActiveFilter =
      !hasPageQueryParam && container && selectedSubcategory && subCatClicked

    if (shouldScrollToActiveFilter) {
      const activeFilter = container.querySelector(`[class*="active"]`)
      if (activeFilter) {
        activeFilter.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center',
        })
      }
    }
  }, [selectedSubcategory, subCatClicked])

  return (
    <div className={s.quickFilters} ref={containerRef}>
      {subcategories.map((subcategory) => {
        if (subcategory.slug === selectedSubcategory?.slug)
          return (
            <SubcategoryChip
              key={subcategory.slug}
              subcategory={subcategory}
              active
              onClick={() => setSubCatClicked(true)}
            />
          )
        return (
          <SubcategoryChip
            key={subcategory.slug}
            subcategory={subcategory}
            onClick={() => setSubCatClicked(true)}
          />
        )
      })}
    </div>
  )
}
